/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddToVenueModel as DigiworkMaitreDPosDtoEmployeeAddToVenueModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/add-to-venue-model';

export interface AddEmployeeToVenues$Params {
      body?: DigiworkMaitreDPosDtoEmployeeAddToVenueModel
}

export function addEmployeeToVenues(http: HttpClient, rootUrl: string, params?: AddEmployeeToVenues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addEmployeeToVenues.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addEmployeeToVenues.PATH = '/api/gmn/Employee/addemployeetovenues';
